import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import videojs from "video.js";
import "video.js/dist/video-js.min.css";
import { LeafletService } from "../../ng-leaflet/services/leaflet.service";


@Component({
  selector: "app-center-overview",
  templateUrl: "./center-overview.component.html",
  styleUrls: ["./center-overview.component.css"],
  // providers: [LeafletService],
})
export class CenterOverviewComponent {
  public leafletOptions: any;
  shutterMap;
  shutterLayerControl;
  type = "中心概况";

  tit1 = true;
  tit2 = false;
  tit3 = false;
  txt = true;
  txt1 = false;
  txt2 = false;
  constructor(private leafletService: LeafletService) {}
  titSwitch(num) {
    if (num == 1) {
      this.tit1 = true;
      this.tit2 = false;
      this.tit3 = false;
      this.txt = true;
      this.txt1 = false;
      this.txt2 = false;
    } else if (num == 2) {
      this.tit1 = false;
      this.tit2 = true;
      this.tit3 = false;
      this.txt = false;
      this.txt1 = true;
      this.txt2 = false;
    } else if (num == 3) {
      // this.getMap()
      this.tit1 = false;
      this.tit2 = false;
      this.tit3 = true;
      this.txt = false;
      this.txt1 = false;
      this.txt2 = true;
    }
  }

  showMP4() {
    let options = {};
    let player = videojs(
      "video",
      { autoplay: false },
      "my-player",
      options,
      function onPlayerReady() {
        videojs.log("播放器准备好了!");

        // In this context, `this` is the player that was created by Video.js.
        this.play();

        this.on("ended", function () {
          videojs.log("播放结束!");
        });
      }
    );
  }

  getMap() {
    // 初始化地图
    this.leafletOptions = {
      center: [36.04933, 103.86035],
      minZoom: 6,
      maxZoom: 6,
      zoom: 6,
      layersControl: false,
      measureCtl: false,
      zoomControl: false,
      defaultExtentControl: false,
      baseLayer: false,
      attributionControl: false,

    };

    setTimeout(() => {
      console.log("这是地图");
      this.shutterMap = L.map(
        'divideMap',
        this.leafletOptions
      );

      // 初始化图层底图
      // const layers = this.initBaseLayers(this.shutterMap);
      // this.shutterLayerControl = L.control
      //   .layers({}, {}, { collapsed: false })
      //   .addTo(this.shutterMap);
      // console.log(this.shutterLayerControl);
      // const vectorMap = L.tileLayer.chinaProvider("TianDiTu.Normal.Map", {
      //   maxZoom: 18
      // });
      // const vectorAnn = L.tileLayer.chinaProvider("TianDiTu.Normal.Annotion", {});

      const vectorMap = L.tileLayer.chinaProvider("GaoDe.Normal.Map", {
        maxZoom: 6,
        minZoom: 6,
      });

      const vecGroup = L.layerGroup([vectorMap]);

      vecGroup.addTo(this.shutterMap);

      var markerIcon = L.AwesomeMarkers.icon({
        icon: "fire",
        prefix: "fa",
        markerColor: "red",
      });
         
      var marker = L.marker([36.03, 103.86], {
        icon: markerIcon,
      })
        .addTo(this.shutterMap)
        .bindPopup("甘肃资源与环境数据应用中心</br><a  href='https://www.gs-sky.com' target='_blank'>https://www.gs-sky.com</a> ")
        .openPopup();
      var marker2 = L.marker([Number(38.932086), Number(100.456242)], {
        icon: markerIcon,
      })
        .addTo(this.shutterMap)
        .bindPopup("张掖分中心</br><a target='blank' href=' https://www.gssgy.com/'> https://www.gssgy.com/</a></br><a target='blank' href=' https://www10.hxu.edu.cn/'> https://www10.hxu.edu.cn/</a>");
      var marker3 = L.marker([Number(34.578529), Number(105.724998)], {
        icon: markerIcon,
      })
        .addTo(this.shutterMap)
        .bindPopup(`天水分中心</br><a target='blank' href='http://www.shsmch.com/'>http://www.shsmch.com/</a></br><a target='blank' href='https://www.gipc.edu.cn/'>https://www.gipc.edu.cn/</a>`);
      var marker4 = L.marker([Number(33.400684), Number(104.921841)], {
        icon: markerIcon,
      })
        .addTo(this.shutterMap)
        .bindPopup("陇南分中心");
      var marker5 = L.marker([Number(35.731026), Number(107.64632412)], {
        icon: markerIcon,
      })
        .addTo(this.shutterMap)
        .bindPopup("庆阳分中心</br><a target='blank' href='https://www.ldxy.edu.cn/sxytjxy/'>https://www.ldxy.edu.cn/sxytjxy/</a></br><a target='blank' href='http://125.74.125.208'>http://125.74.125.208</a>");

      // this.shutterMap.setView(marker.getLatLng(), 6);
    }, 100);
  }
}
